import client from '@/api/client';
import { gql } from '@apollo/client';

const getClientState = (
  state: string,
) => client
  .query({
    query: gql`
    query($state: String) {
      getClientState(
        state: $state
      ) {
        id
        state
        value
      }
    }
  `,
    variables: {
      state,
    },
  });

const setClientState = (
  state: string,
  value: string,
) => client
  .mutate({
    mutation: gql`
      mutation(
        $state: String,
        $value: String
      ) {
        setClientState(
          state: $state,
          value: $value
        ) {
          status
        }
      }
    `,
    variables: {
      state,
      value,
    },
  });

const updateClientState = (
  id: number,
  state: string,
  value: string,
) => client
  .mutate({
    mutation: gql`
    mutation(
      $id: Int,
      $state: String,
      $value: String
    ) {
      updateClientState(
        id: $id,
        state: $state,
        value: $value
      ) {
        status
      }
    }
  `,
    variables: {
      id,
      state,
      value,
    },
  });

const deleteClientState = (
  id: number,
) => client
  .mutate({
    mutation: gql`
    mutation(
      $id: Int
    ) {
      deleteClientState(
        id: $id
      ) {
        status
      }
    }
  `,
    variables: {
      id,
    },
  });

export default {
  getClientState,
  setClientState,
  updateClientState,
  deleteClientState,
};
